
import { AjaxHelper } from 'CoreHome';
import { defineComponent } from 'vue';
import IconMagic from '../Icon/IconMagic.vue';
import IconClose from '../Icon/IconClose.vue';
import Chat from '../Chat/Chat.vue';

export default defineComponent({
  components: {
    Chat,
    IconMagic,
    IconClose,
  },
  props: {
    displayOffcanvas: {
      type: Boolean,
      default: false,
    },
    reportId: {
      type: String,
      required: true,
    },
    aiName: {
      type: String,
      required: true,
    },
    aiLabel: {
      type: String,
      required: true,
    },
    aiColor: {
      type: String,
      default: '#3450a3',
    },
    apiMethod: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      messages: [],
    };
  },
  computed: {
    offcanvasClass(): Array<string> {
      return [
        'ai-chat-insight-offcanvas',
        this.displayOffcanvas ? 'active' : '',
      ];
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onSubmit() {
      this.$refs.chat.onSubmit();
    },
  },
});
